import Axios from "axios";
import React, { useEffect, useState } from "react";
import SSCityReg from "./SSCityReg";

const SoulStrings = () => {
    const [soulStringsreg, setSoulStringsreg] = useState([]);

    const cities = ["Banglore", "Jaipur", "Delhi", "Shillong", "Goa", "Mumbai"];

    const getReg = () => {
        Axios.post(
            "https://jarvis.moodi.org/livewire/get_ss_reg",
            {
                cookies: "ShubhamRandi",
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
            .then((res) => setSoulStringsreg(res.data))
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        getReg();
    }, []);

    return (
        <div className="container-fluid">
            <h2>
                SoulStrings Registrations (Total reg - {soulStringsreg.length})
            </h2>
            <div class="accordion" id="accordionExample">
                {cities.map((city) => {
                    let cityReg = soulStringsreg.filter(
                        (element) => element.city === city
                    );
                    return (
                        <div class="accordion-item">
                            <h2 class="accordion-header">
                                <button
                                    class="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#${city}`}
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    {city} ({cityReg.length})
                                </button>
                            </h2>
                            <div
                                id={city}
                                class="accordion-collapse collapse"
                                data-bs-parent="#accordionExample"
                            >
                                <div class="accordion-body">
                                    <SSCityReg city={city} cityReg={cityReg} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SoulStrings;
